export const API_CONSTANTS = {

  Auth: {
    RefreshAccessToken: "Users/RefreshAccessToken",
    ChangePassword: "UserSettings/UpdatePassword",
  },

  //Users
  Moderation: {
    Login: "Moderation/ModeratorLogin",
    GetUserAccountByToken: 'User/GetUserAccountByToken'
  },

  Slots: {
    GetAllLinks: "SlotsModeration/GetAllLinks",
    ChangeMockInterviewLink: 'SlotsModeration/ChangeMockInterviewLink/',
    ChangeLinkedInWorkshopLink: 'SlotsModeration/ChangeLinkedInWorkshopLink/',
  },

  Packages: {
    GetAllCVs: "PackagesModeration/GetAllCVs/",
    GetAllInterviews: "PackagesModeration/GetAllInterviews/",
    GetAllWorkshops: "PackagesModeration/GetAllWorkshops/",
    UpdateCV: "PackagesModeration/UpdateCV",
    UpdateWorkshop: "PackagesModeration/UpdateWorkshop",
    ProceedWithCV: "PackagesModeration/AdvanceCVStatus/",
    ProceedWithInterview: "PackagesModeration/AdvanceInterviewStatus/",
    ProceedWithWorkshop: "PackagesModeration/AdvanceWorkshopStatus/",
    GetProcessOrders: "PackagesModeration/GetProcessOrders",
    GetProcessOrder: "PackagesModeration/GetProcessOrder/",
    CopyAllProcessData: "PackagesModeration/CopyAllProcessData/",
    UpdateProcessStatus: "PackagesModeration/UpdateProcessStatus/",
  },

  Currency: {
    GetSystemStats: "Currency/GetSystemStats",
    UpdateTaxfee: "Currency/UpdateTaxfee/",
    UpdateMonthlyPlanPrice: "Currency/UpdateMonthlyPrice/",
    UpdateYearlyPlanPrice: "Currency/UpdateYearlyPrice/",
  },

  Coupons: {
    GetAll: "CouponsModeration/GetAll",
    GetById: "CouponsModeration/GetById/",
    Create: "CouponsModeration/Create",
    Update: "CouponsModeration/Update",
    EndCoupon: "CouponsModeration/EndCoupon/",
    Delete: "CouponsModeration/Delete/",
  },

  PackageCatalog: {
    GetAll: "PackageCatalogModeration/GetAll",
    GetById: "PackageCatalogModeration/GetById/",
    Create: "PackageCatalogModeration/Create",
    Update: "PackageCatalogModeration/Update",
    Delete: "PackageCatalogModeration/Delete/",
  },

  NotificationRecipients: {
    GetAll: "NotificationRecipientsModeration/GetAll",
    GetById: "NotificationRecipientsModeration/GetById/",
    GetNotificationTypes: "NotificationRecipientsModeration/GetNotificationTypes",
    Create: "NotificationRecipientsModeration/Create",
    Update: "NotificationRecipientsModeration/Update",
    Delete: "NotificationRecipientsModeration/Delete/",
  },

  SubscriptionPlans: {
    GetCandidateCatalog: "SubscriptionPlansModeration/candidate/catalog",
    GetProviderCatalog: "SubscriptionPlansModeration/provider/catalog",
    CreateCandidateDefinition: "SubscriptionPlansModeration/candidate/definitions",
    UpdateCandidateDefinition: "SubscriptionPlansModeration/candidate/definitions/",
    CreateCandidateVersion: "SubscriptionPlansModeration/candidate/versions",
    UpdateCandidateVersion: "SubscriptionPlansModeration/candidate/versions/",
    DeleteCandidateVersion: "SubscriptionPlansModeration/candidate/versions/",
    CreateProviderDefinition: "SubscriptionPlansModeration/provider/definitions",
    UpdateProviderDefinition: "SubscriptionPlansModeration/provider/definitions/",
    CreateProviderVersion: "SubscriptionPlansModeration/provider/versions",
    UpdateProviderVersion: "SubscriptionPlansModeration/provider/versions/",
    DeleteProviderVersion: "SubscriptionPlansModeration/provider/versions/",
  },

  PlatformSettings: {
    GetCandidatePaywall: "PlatformSettingsModeration/candidate-paywall",
    SetCandidatePaywall: "PlatformSettingsModeration/candidate-paywall",
  },

  UserModeration: {
    UpdateUser: "UserModeration/UpdateUser/",
    ToggleUserStatus: "UserModeration/ToggleUserStatus/",
    ChangeUserNumber: "UserModeration/ChangeUserNumber/",
    ChangeUserEmail: "UserModeration/ChangeUserEmail/",
    ChangeUserImage: "UserModeration/ChangeUserImage/",
    GetUserPackages: "UserModeration/GetUserPackages/",
    // ResetUserPassword: "UserModeration/ResetUserPassword/",
  },

  Moderator: {
    SearchModerators: "Moderator/SearchModerators/",
    CreateModeratorAccount: "Moderator/CreateModeratorAccount/",
    GetModerator: "Moderator/GetModerator/",
    GetAllModerators: "Moderator/GetAllModerators/",
    UpdateModerator: "Moderator/UpdateModerator/",
    DeleteModerator: "Moderator/DeleteModerator/",
  },

  Roles: {
    GetMyPermissions: "Role/GetMyPermissions",
    GetAll: "Role/GetAll",
    GetPermissions: "Role/GetPermissions",
    GetById: "Role/GetById/",
    Create: "Role/Create",
    UpdateClaims: "Role/UpdateClaims",
    Delete: "Role/Delete/",
    AssignStaffRole: "Role/AssignStaffRole",
  },

  Candidate: {
    SearchCandidates: "CandidateModeration/SearchCandidates/",
    ExportCandidates: "CandidateModeration/ExportCandidates/",
    CreateCandidateAccount: "CandidateModeration/CreateCandidateAccount/",
    GetCandidateDetails: "CandidateModeration/GetCandidateDetails/",
    GetCandidatePackages: "CandidateModeration/GetCandidatePackages/",
    GetCandidateOtherDetails: "CandidateModeration/GetCandidateOtherDetails/",
    GetAllCandidates: "CandidateModeration/GetAllCandidates/",
    UpdateCandidateDetails: "CandidateModeration/UpdateCandidateDetails/",
    ChangeCandidateResume: "CandidateModeration/ChangeCandidateResume/",
    GetCandidateBookmarks: "CandidateModeration/GetCandidateBookmarks/",
    GetCandidateOpportunities: "CandidateModeration/GetCandidateOpportunities/",
    ToggleTamheerStatus: "CandidateModeration/ToggleTamheerStatus/",
    ToggleFreshGradStatus: "CandidateModeration/ToggleFreshGradStatus/",
    ToggleInsuranceStatus: "CandidateModeration/ToggleInsuranceStatus/",
    GetCandidateCertificates: "CandidateModeration/GetCandidateCertificates/",
    UpdateCandidateCertificate: "CandidateModeration/UpdateCandidateCertificate",

    Profile: {
      //Get Details
      GetCandidateEducaction: "CandidateProfileModeration/GetCandidateEducation/",
      GetCandidateExperience: "CandidateProfileModeration/GetCandidateExperience/",
      GetCandidateVolunteer: "CandidateProfileModeration/GetCandidateVolunteer/",
      GetCandidateProjects: "CandidateProfileModeration/GetCandidateProjects/",
      //Add Details
      AddCandidateEducation: "CandidateProfileModeration/AddEducation",
      AddCandidateExperience: "CandidateProfileModeration/AddExperience",
      AddCandidateVolunteer: "CandidateProfileModeration/AddVolunteerExperience",
      AddCandidateProject: "CandidateProfileModeration/AddProject",
      //Update Details
      UpdateCandidateEducation: "CandidateProfileModeration/UpdateEducation",
      UpdateCandidateExperience: "CandidateProfileModeration/UpdateExperience",
      UpdateCandidateVolunteer: "CandidateProfileModeration/UpdateVolunteerExperience",
      UpdateCandidateProject: "CandidateProfileModeration/UpdateProject",
      //Delete Details
      DeleteCandidateEducation: "CandidateProfileModeration/DeleteEducation/",
      DeleteCandidateExperience: "CandidateProfileModeration/DeleteExperience/",
      DeleteCandidateVolunteer: "CandidateProfileModeration/DeleteVolunteerExperience/",
      DeleteCandidateProject: "CandidateProfileModeration/DeleteProject/",
      //Add Other Details
      AddCandidateLinks: "CandidateProfileModeration/AddCandidateLinks/",
      AddCandidateCertificates: "CandidateProfileModeration/AddCandidateCertificate/",
      AddCandidateLanguages: "CandidateProfileModeration/AddCandidateLanguages/",
      AddCandidateIntents: "CandidateProfileModeration/AddCandidateIntents/",
      AddCandidateSkills: "CandidateProfileModeration/AddCandidateSkill/",
      AddCandidateInterests: "CandidateProfileModeration/AddCandidateInterest/",
      //Delete Other Details
      DeleteCandidateLink: "CandidateProfileModeration/DeleteCandidateLink/",
      DeleteCandidateCertificate: "CandidateProfileModeration/DeleteCandidateCertificate/",
      DeleteCandidateLanguage: "CandidateProfileModeration/DeleteCandidateLanguage/",
      DeleteCandidateIntent: "CandidateProfileModeration/DeleteCandidateIntent/",
      DeleteCandidateSkill: "CandidateProfileModeration/DeleteCandidateSkill/",
      DeleteCandidateInterest: "CandidateProfileModeration/DeleteCandidateInterest/",
    },

  },

  Provider: {
    SearchProviders: "ProviderModeration/SearchProviders/",
    ExportProviders: "ProviderModeration/ExportProviders/",
    CreateProviderAccount: "ProviderModeration/CreateProviderAccount",
    GetAllProviders: "ProviderModeration/GetAllProviders",
    GetProviderDetails: "ProviderModeration/GetProviderDetails/",
    UpdateProviderDetails: "ProviderModeration/UpdateProviderDetails/",
    ToggleProviderStatus: "ProviderModeration/ToggleProviderStatus/",
    RejectProvider: "ProviderModeration/RejectProvider/",
    GetProviderAds: "ProviderModeration/GetProviderAds/",
    GetProviderOpportunities: "ProviderModeration/GetProviderOpportunities/",
    GetSubscriptionDetails: "ProviderModeration/GetSubscriptionDetails/",
    ToggleSubscriptionBypass: "ProviderModeration/ToggleProviderSubscriptionBypass/",
  },

  Opportunity: {
    SearchOpportunities: "OpportunityModeration/SearchOpportunities/",
    CreateOpportunity: "OpportunityModeration/CreateOpportunity/",
    UpdateOpportunity: "OpportunityModeration/UpdateOpportunity/",
    UpdateOpportunityDetails: "OpportunityModeration/UpdateOpportunityDetails/",
    GetAllOpportunities: "OpportunityModeration/GetAllOpportunities/",
    ExportOpportunities: "OpportunityModeration/ExportOpportunities",
    GetOpportunity: "OpportunityModeration/GetOpportunity/",
    GetOpportunityDetails: "OpportunityModeration/GetOpportunityDetails/",
    GetOpportunityBookmarks: "OpportunityModeration/GetOpportunityBookmarks/",
    ChangeOpportunityCover: "OpportunityModeration/ChangeOpportunityCover",
    DeleteOpportunity: "OpportunityModeration/DeleteOpportunity/",
    ToggleOpportunityPinned: "OpportunityModeration/ToggleOpportunityPinned/",

    Applicants: {
      GetApplicantsByStatus: "ApplicantModeration/GetApplicantsByStatus",
      GetApplicationDetails: "ApplicantModeration/GetApplicationDetails/",
      AcceptApplication: "ApplicantModeration/AcceptApplication/",
      RejectApplication: "ApplicantModeration/RejectApplication/",

    },

    Questions: {
      GetOpportunityQuestions: "OpportunityModeration/GetOpportunityQuestions/",
      AddOpportunityQuestion: "OpportunityModeration/AddOpportunityQuestion",
      DeleteOpportunityQuestion: "OpportunityModeration/DeleteOpportunityQuestion/",
    },
  },

  CollectionSource: {
    GetAll: "CollectionSourceModeration/GetAll/",
    Get: "CollectionSourceModeration/Get/",
    Save: "CollectionSourceModeration/Save",
    SetEnabled: "CollectionSourceModeration/SetEnabled/",
    Archive: "CollectionSourceModeration/Archive/",
    Restore: "CollectionSourceModeration/Restore/",
    QueueScan: "CollectionSourceModeration/QueueScan/",
    RetryFailedLinks: "CollectionSourceModeration/RetryFailedLinks/",
  },
  CollectionDraft: {
    GetAll: "CollectionDraftModeration/GetAll/",
    Get: "CollectionDraftModeration/Get/",
    Save: "CollectionDraftModeration/Save",
    Publish: "CollectionDraftModeration/Publish",
    Reject: "CollectionDraftModeration/Reject",
  },

  Ads: {
    GetAds: "AdsModeration/GetAds/",
    CreateAd: "AdsModeration/CreateAd",
    DeleteAd: "AdsModeration/DeleteAd/",
    AddLinkToAd: "AdsModeration/AddLinkToAd",
    ChangeAdStatus: "AdsModeration/ChangeAdStatus/",
  },

  Statistics: {
    GetStatistics: "Moderation/GetDashboardStatistics",
    GetAnalyticsDashboard: "Moderation/GetAnalyticsDashboard",
    GetMostViewedOpportunities: "Moderation/GetMostViewedOpportunities",
  },

  ReportsManagement: {
    GetBugReports: "BugReports/GetBugReports",
  },

  Requests: {
    GetAllRequests: "ContactRequestModeration/GetAllRequests/",
  },

  CompanyInterests: {
    GetAll: "CompanyInterestModeration/GetAll/",
  },

  Payments: {
    GetSuccessfulPayments: "PaymentsModeration/GetSuccessfulPayments",
  },

  Campaigns: {
    CreatePNC: "Campaigns/CreatePNC",
    GetPNCs: "Campaigns/GetPNCs",
    CreateSMSC: "Campaigns/CreateSms",
    GetSMSCampaigns: "Campaigns/GetSms",
  },

  //Authentication

}
